import React, { Component } from 'react';
import { Container, Row, Col, Button, Input } from 'reactstrap';
import { API } from '../../Logic/API';
import { Storage } from '../../Logic/Storage';
import '../Spacing.css';

export class AdminLogin extends Component {
    constructor(props) {
        super(props);

        this.state = { login: null, password: null }

        this.props.showHostingNav(false);
    }

    onLogin(login) {
        this.setState({ login: login });
    }

    onPassword(pw) {
        this.setState({ password: pw });
    }

    canLogin() {
        return this.state.login !== null &&
            this.state.login.length > 0 &&
            this.state.password !== null &&
            this.state.password.length > 0;
    }

    tryLogin() {
        let credentials = {
            'Login': this.state.login,
            'Password' : this.state.password
        }
        API.post('/gamehost/login', credentials)
            .then(resp => resp.json())
            .then(data => {
                this.handleLogin(data.Token);
            })
            .catch(e => {

            });
    }

    handleLogin(token) {
        if (!token) {
            throw Error("Login failed");
        }
        Storage.setSecurityToken(token);
        this.props.history.push('/hosting/game');
    }

    render() {
        return (
            <Container>
                <Row>
                    <Col className="hidden-md"></Col>
                    <Col lg="6"><h1>Game Host Login</h1></Col>
                    <Col className="hidden-md"></Col>
                </Row>
                <Row>
                    <Col><p className="space-bottom"></p></Col>
                </Row>
                <Row>
                    <Col className="hidden-md"></Col>
                    <Col lg="6">
                        <Input type="text" placeholder="Benutzername" onChange={e => this.onLogin(e.target.value)} />
                    </Col>
                    <Col className="hidden-md"></Col>
                </Row>
                <Row>
                    <Col className="hidden-md"></Col>
                    <Col lg="6">
                        <Input type="password" className="space-top space-bottom" placeholder="Passwort" onChange={e => this.onPassword(e.target.value)}/>
                    </Col>
                    <Col className="hidden-md"></Col>
                </Row>
                <Row>
                    <Col className="hidden-md"></Col>
                    <Col lg="6">
                        <Button type="button" color={this.canLogin() ? "primary" : "secondary"} size="lg" block onClick={() => this.tryLogin()} disabled={!this.canLogin()}>Login</Button>
                    </Col>
                    <Col className="hidden-md"></Col>
                </Row>
            </Container>    
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Admin/AdminLogin.jsx